import React, { useState } from 'react';
import { TableList, Typography, Autocomplete, WithInfoIcon } from 'seagull';
import styles from "./MapAccountsRow.module.scss";
import { matchSorter } from 'match-sorter';
import { MapStatusView } from "../MapStatusView";
export function MapAccountsRow(_ref) {
  let {
    anchorAccount,
    tooltip,
    accounts,
    selectedAccountId,
    onLink,
    'data-testid': testid
  } = _ref;
  const [selectedOption, setSelectedOption] = useState(() => accounts === null || accounts === void 0 ? void 0 : accounts.find(account => account.id === selectedAccountId));
  const [mapStatus, setMapStatus] = useState(() => selectedOption ? 'mapped' : 'notMapped');

  const _onChange = async account => {
    if (!account) {
      return;
    }

    setMapStatus('mapping');
    setSelectedOption(account);

    try {
      await onLink(account);
      setMapStatus(account ? 'mapped' : 'notMapped');
    } catch (e) {
      setMapStatus('failedToMap');
    }
  };

  return /*#__PURE__*/React.createElement(TableList.Row, {
    "data-testid": testid,
    items: [{
      value: /*#__PURE__*/React.createElement("div", {
        className: styles.accountToSetColumn
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.textWrapper
      }, /*#__PURE__*/React.createElement(Typography, {
        ellipsis: true
      }, anchorAccount), /*#__PURE__*/React.createElement(Typography, {
        skin: "error"
      }, "*")), /*#__PURE__*/React.createElement(WithInfoIcon, {
        info: tooltip
      }))
    }, {
      value: /*#__PURE__*/React.createElement("div", {
        "data-testid": "qbo-accounts",
        className: styles.autocompleteWrapper
      }, /*#__PURE__*/React.createElement(Autocomplete, {
        "data-testid": "".concat(testid, "-autocomplete"),
        value: selectedOption,
        options: accounts || [],
        onChange: (_, newOption) => _onChange(newOption),
        renderOption: _ref2 => {
          let {
            name
          } = _ref2;
          return /*#__PURE__*/React.createElement(Typography, {
            ellipsis: true
          }, name);
        },
        getOptionSelected: (option, value) => option.id == value.id,
        getOptionLabel: option => option.name,
        filterOptions: (options, _ref3) => {
          let {
            inputValue
          } = _ref3;
          return matchSorter(options, inputValue, {
            keys: ['name']
          });
        },
        noOptionsText: "No QuickBooks accounts",
        textFieldProps: {
          placeholder: 'Select account',
          error: mapStatus === 'failedToMap'
        },
        selectOnFocus: true,
        disableClearable: true,
        multiple: false,
        freeSolo: false
      }))
    }, {
      value: /*#__PURE__*/React.createElement(MapStatusView, {
        mapStatus: mapStatus
      })
    }]
  });
}